import React, { FC } from "react"
import { Title, TitleProps } from "dash-styled"

interface SettingsSectionProps {
    title: string
    titleComponent?: TitleProps["component"]
}

export const SettingsSection: FC<SettingsSectionProps> = ({
    title,
    titleComponent = "h2",
    children
}) => {
    return (
        <section className="py-10">
            <Title
                variant="heading2"
                component={titleComponent}
                weight="semibold"
            >
                {title}
            </Title>
            {children}
        </section>
    )
}
